import { type FC } from 'react';

type Photo24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Photo24: FC<Photo24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <path d="M4.667 21C4.216 21 3.826 20.835 3.496 20.504C3.165 20.174 3 19.784 3 19.333V4.667C3 4.217 3.165 3.826 3.496 3.496C3.826 3.165 4.216 3 4.667 3H19.333C19.783 3 20.174 3.165 20.504 3.496C20.835 3.826 21 4.217 21 4.667V19.333C21 19.783 20.835 20.174 20.504 20.504C20.174 20.835 19.783 21 19.333 21H4.667ZM4.667 19.333H19.333V4.667H4.667V19.333ZM5.933 17.05H18.083L14.383 12.117L10.183 16.3L8.883 13.183L5.933 17.05Z" />
        </svg>
    );
};

export default Photo24;
